import {Domain} from '../domains/domain';

export class CreditorStatus {
  public id?: string;
  public name: string;
  public domain?: Domain;
}
